export const breakpoints = {
  xs: 0,
  sm: 393,
  md: 768,
  lg: 1025,
  xl: 1280,
  "2xl": 1440,
  "3xl": 1728,
  "4xl": 1920,
  "5xl": 2560,
} as const
